<script lang="ts">
  import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
  import { Icon } from "@getprovi/craft-svelte";
  import { BoxArrowUpRight } from "@getprovi/craft-svelte-icons";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import {
    getControlStateAuthenticationService,
    loadRetailerUserAuthentications,
  } from "@retailer/services/retailer_user_authentications_service";
  import type { ControlStateIntegration } from "@shared/services/retailer_user_authentication/base";

  export let distributorId: number;

  let authService: ControlStateIntegration = getControlStateAuthenticationService();
  let retries = 0;
  let refresh = async () => {
    setTimeout(async () => {
      let res = await loadRetailerUserAuthentications();
      if (res && res.length == 0) {
        retries++;
        if (retries < 100) {
          refresh();
        }
      }
    }, 1500);
  };
</script>

<div class="flex-col justify-between gap-32" style="height: 100%;">
  <div class="justify-start">
    <div class="flex flex-column items-center">
      <img
        src={window["C"].IMAGE_PATHS["vermont-logo.png"]}
        alt="Vermont"
        style="max-width: 147px;"
        class="fizz-stack-32"
      />
      <h2 class="flex-1 text-center fizz-stack-32" style="max-width: 220px;">
        We've partnered with Vermont!
      </h2>
    </div>
    <div
      class="bg-neutral rounded-sm fizz-inset-horizontal-16 fizz-inset-vertical-24 fizz-stack-32"
    >
      <h4 class="fizz-text-strong text-center fizz-stack-24">
        <p>Verify Your</p>
        <p>MyVermont DLL Account</p>
      </h4>
      <p class="text-center fizz-text-subdued fizz-stack-4">Have an account for:</p>
      <p class="text-center fizz-text-strong fizz-stack-16">{$CurrentRetailerStore.name}?</p>
      <div class="flex items-center justify-center">
        <a
          class="craft-button btn-primary btn-base cursor-pointer justify-center btn-stretch"
          data-testid="vermont-log-in-link"
          href={authService.loginUrl()}
          rel="noreferrer"
          target="_blank"
          on:click={() => {
            loginEvent("pending", distributorId, { step: "intro" });
            refresh();
          }}
        >
          <span class="btn-text">Log In</span>
          <Icon iconName={BoxArrowUpRight} />
        </a>
      </div>
    </div>
  </div>

  <div class="justify-end">
    <div class="fizz-text-subdued">
      <div class="text-center fizz-stack-24">
        <p class="fizz-text-strong">No DLL Account?</p>
        <span
          >Sign up <a
            href="https://my.vermont.gov/signin/register?from=dllportal"
            rel="noreferrer"
            target="_blank">here.</a
          ></span
        >
      </div>
      <div class="text-center fizz-stack-24">
        <p class="fizz-text-strong">Need help?</p>
        <a
          href="https://support.provi.com/s/article/Getting-Started-with-802Spirits-Connect"
          rel="noreferrer"
          target="_blank">FAQs</a
        >
        <p>Contact myVermont Service Center at <a href="tel:+18028282345">802-828-2345</a></p>
      </div>
    </div>
  </div>
</div>
